import React from 'react'

export default function checkCircle(color, size) {
    return (<svg id="Layer_1" version="1.1" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" width={size} height={size} >
        <g>
            <path d="M24,46C11.9,46,2,36.1,2,24S11.9,2,24,2s22,9.9,22,22S36.1,46,24,46z M24,4C13,4,4,13,4,24c0,11,9,20,20,20   c11,0,20-9,20-20C44,13,35,4,24,4z" fill={color} />
        </g>
        <g>
            <polygon points="20,34.1 11.3,25.4 12.7,23.9 20,31.2 35.3,15.9 36.7,17.4 " fill={color} />
        </g>
    </svg>)
}